// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ReservationsListBase\ReservationsListViewModelBase.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';

// ReservationsDashboardRowData is the class that ReservationsDashboardRow serializes to/from
export interface ReservationsDashboardRowData {
    Id : number;
	
    Reservation : BerthReservationData | null;
	
    CanBook : boolean;
    CanCancel : boolean;
}

// ReservationsDashboardRowOptions is the class which may be passed to the ReservationsDashboardRow constructor to define optional initial data values
export interface ReservationsDashboardRowOptions {
    Id : number;
	
    Reservation? : BerthReservationOptions | null;
	
    CanBook? : boolean;
    CanCancel? : boolean;
}

export class ReservationsDashboardRow {
    public Id : DataSignal<number>;
	
    public Reservation : DataSignal<BerthReservation | null>;
	
    public CanBook : DataSignal<boolean>;
    public CanCancel : DataSignal<boolean>;

    constructor();
    constructor(data : ReservationsDashboardRowOptions);
    constructor(data: ReservationsDashboardRowOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Reservation = S.value<BerthReservation | null>(null);
	    
        this.CanBook = jsonableObservable(S.value<boolean>(data && data.CanBook !== undefined ? data.CanBook : false));
        this.CanCancel = jsonableObservable(S.value<boolean>(data && data.CanCancel !== undefined ? data.CanCancel : false));
    }

    static key(obj : ReservationsDashboardRow) {
        return obj.Id();
    }
    
    static dataKey(obj : ReservationsDashboardRowOptions) {
        return obj.Id;
    }

    static update(obj : ReservationsDashboardRow, data : ReservationsDashboardRowOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.CanBook !== undefined) obj.CanBook(data.CanBook);
            if (data.CanCancel !== undefined) obj.CanCancel(data.CanCancel);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ReservationsDashboardRow.ts